import { render, staticRenderFns } from "./PortailAutresPages.vue?vue&type=template&id=2d4bdb80&scoped=true&"
import script from "./PortailAutresPages.vue?vue&type=script&lang=js&"
export * from "./PortailAutresPages.vue?vue&type=script&lang=js&"
import style0 from "./PortailAutresPages.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PortailAutresPages.vue?vue&type=style&index=1&id=2d4bdb80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4bdb80",
  null
  
)

export default component.exports